// extracted by mini-css-extract-plugin
export default {"WalletConnected":"WalletConnected_WalletConnected__Mur+n","textSection":"WalletConnected_textSection__mObH6"};